import { IProductTemplateLayoutProps } from 'productTemplate/types/IProductTemplateLayoutProps'
import { useContext } from 'react'
import { renderUntil } from 'shared/hocs/render'
import { styles } from 'shared/lib'
import colors from 'shared/lib/colors'
import styled from 'styled-components'

import MobileProductPictureCarousel from './MobileProductPictureCarousel'
import ProductDetails from './ProductDetails'
import { ProductTemplateContext } from './ProductTemplateContextProvider'
import ProductTitle from './ProductTitle'

const ProductMobileLayout = styled.div`
  background-color: ${colors.FC2_WHITE};
  padding: 30px ${styles.mobilePageLayoutPadding} 0;
`

const ProductInfo = styled.div`
  display: flex;
  justify-content: center;
`

const ProductTemplateMobileLayout = (props: IProductTemplateLayoutProps) => {
  const { productTemplate } = useContext(ProductTemplateContext)
  const { className } = props
  return (
    <ProductMobileLayout className={className}>
      <div>
        <ProductTitle
          brand={productTemplate.brand}
          name={productTemplate.name}
          sku={productTemplate.sku}
          description={productTemplate.description}
          releaseDate={productTemplate.releaseDate.shortDisplay}
        />
        <MobileProductPictureCarousel pictures={productTemplate.pictures} />
      </div>
      <ProductInfo>
        <ProductDetails />
      </ProductInfo>
    </ProductMobileLayout>
  )
}
export default renderUntil.large(ProductTemplateMobileLayout)
